import { memo } from 'react';
import { Divider, Flex } from '@chakra-ui/react';

import { PLAN_FILTER_PILL_HEIGHT, PLAN_REVAMP_RADIUS_SM, neutral } from '../planPageRevampUi';

import PlanFilterByControl from './PlanFilterByControl';
import PlanGroupByControl from './PlanGroupByControl';

interface Properties {
  refetchRequest: () => void;
}

const PlanFilterGroupPill = ({ refetchRequest }: Properties) => {
  return (
    <Flex
      h={PLAN_FILTER_PILL_HEIGHT}
      alignItems='center'
      // 12px between the two halves against 8px inside each one: the wider gap
      // is what groups an icon with its own label instead of leaving icon,
      // label, chevron and divider all equally spaced, which is what made this
      // pill read as a row of loose parts.
      gap={3}
      px={3}
      // No `py` — the row is a fixed height and centres its children. The old
      // 7px was tuned against the previous 32px pill and now fought it.
      border='1px solid'
      borderColor={neutral.border}
      borderRadius={PLAN_REVAMP_RADIUS_SM}
      bg={neutral.surface}
      overflow='hidden'
      flexShrink={0}
    >
      <PlanFilterByControl onApplyFilters={refetchRequest} />

      <Divider orientation='vertical' h='16px' borderColor={neutral.border} flexShrink={0} />

      <PlanGroupByControl />
    </Flex>
  );
};

export default memo(PlanFilterGroupPill);
